export const THEME_STORAGE_KEY = "eurocTheme";
export const LIGHT_THEME = "light";
export const DARK_THEME = "dark";

export function normalizeTheme(theme) {
  return theme === DARK_THEME ? DARK_THEME : LIGHT_THEME;
}

export function getStoredTheme() {
  if (typeof window === "undefined") return LIGHT_THEME;
  return normalizeTheme(window.localStorage.getItem(THEME_STORAGE_KEY));
}

export function applyTheme(theme) {
  const normalizedTheme = normalizeTheme(theme);
  if (typeof document === "undefined") return normalizedTheme;

  document.documentElement.setAttribute("data-theme", normalizedTheme);
  document.documentElement.style.colorScheme = normalizedTheme;
  return normalizedTheme;
}

export function saveTheme(theme) {
  const normalizedTheme = applyTheme(theme);
  if (typeof window !== "undefined") {
    window.localStorage.setItem(THEME_STORAGE_KEY, normalizedTheme);
  }
  return normalizedTheme;
}

export function initTheme() {
  return applyTheme(getStoredTheme());
}
